module.exports = __webpack_public_path__ + "static/media/oitoneutral.fd2f2fb9.svg";